module.exports = __webpack_public_path__ + "img/bl.dae94f54.png";